// extracted by mini-css-extract-plugin
export default {"accounts":"HeaderNavigation_accounts__JhLfR","image":"HeaderNavigation_image__HT1MF","iconVip":"HeaderNavigation_iconVip__-Hrgl","menu":"HeaderNavigation_menu__pVBXi"};